import { Component, input, output } from '@angular/core';
import { NgIcon, provideIcons } from '@ng-icons/core';
import { lucidePencil, lucidePlus } from '@ng-icons/lucide';
import { ButtonComponent } from '@3ddv/software-division-components/generic/button';

@Component({
  selector: 'gs-event-attach-cell',
  imports: [ButtonComponent, NgIcon],
  viewProviders: [provideIcons({ lucidePencil, lucidePlus })],
  template: `
    <span class="attach-count">{{ count() }}</span>
    @if (editable()) {
      <sdc-button
        variant="glass"
        size="sm"
        [title]="title()"
        (onClick)="clicked.emit()">
        <ng-icon
          [name]="icon() === 'plus' ? 'lucidePlus' : 'lucidePencil'"
          aria-hidden="true" />
        <span class="sr-only">{{ title() }}</span>
      </sdc-button>
    }
  `,
  styles: [
    `
      :host {
        align-items: center;
        display: inline-flex;
        gap: 0.5rem;
      }
    `,
  ],
})
export class GsEventAttachCellComponent {
  readonly count = input.required<number>();
  readonly icon = input<'pencil' | 'plus'>('pencil');
  readonly title = input('');
  readonly editable = input(true);

  readonly clicked = output<void>();
}
